import { ButtonCloud } from '@experimental-components/ButtonCloud';
import { useImportMenuModal } from 'components/MenuMakeImport/hooks';
import { useTranslation } from 'react-i18next';
import useUserStore from 'hooks/useUserStore';
import { useLocation } from 'react-router-dom';
import { MENU_ROUTES } from 'utils/menuMaker/constants';

const PATHS_WITH_IMPORT_BUTTON = ['/menus', '/menus/resume', `${MENU_ROUTES.RESUME}`, `${MENU_ROUTES.MENUS}`];

export const ImportButton = () => {
  const location = useLocation();

  const { storeState: { selected } = {} } = useUserStore();

  const isDraftStore = selected?.isDraft;

  const { t } = useTranslation('menuMaker');
  const { handleOpen } = useImportMenuModal();

  if (!isDraftStore || !PATHS_WITH_IMPORT_BUTTON.includes(location.pathname)) return null;

  return <ButtonCloud onClick={handleOpen}>{t('menuMaker:buttons.importMenu')}</ButtonCloud>;
};
